import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { getLocalTranslations, getCurrentLanguage } from "./localStorage";

import enTranslations from "../locales/en.json";
import ruTranslations from "../locales/ru.json";
import kkTranslations from "../locales/kz.json";
import cnTranslations from "../locales/cn.json";

const getInitialResources = () => {
  const cachedTranslations = getLocalTranslations();
  
  if (cachedTranslations) {
    return cachedTranslations;
  }
  
  return {
    kz: { translation: kkTranslations },
    en: { translation: enTranslations },
    ru: { translation: ruTranslations },
    cn: { translation: cnTranslations },
  };
};

const getInitialLanguage = () => {
  const savedLanguage = getCurrentLanguage();
  return savedLanguage || navigator.language?.split('-')[0] || 'en';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    lng: getInitialLanguage(),
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
    resources: getInitialResources(),
    react: {
      useSuspense: true,
    },
    returnNull: false,
    returnEmptyString: false,
    saveMissing: false,
  });

export default i18n;